// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"PaymentPage_buttonsWrapper__35X91","toggle":"PaymentPage_toggle__4AnFy"};